import React, { createContext, useState, useEffect, useContext } from 'react';
import commonApi from '../utils/api';
import { CommonContext } from './CommonContext';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import moment from 'moment';
import { states } from '../utils/config';

export const MerchantContext = createContext();

const initialFilters = {
    searchBy: 'company_name',
    searchValue: '',
    status: '',
};

export function MerchantContextProvider({ children }) {
    const { user, setModalAlert, setOpenAlert, setAlertMessage, setSeverity, rowData, setRowData } = useContext(CommonContext);

    const [addModal, setAddModal] = useState(false);
    const [firstLoading, setFirstLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [viewData, setViewData] = useState('');
    const [allData, setAllData] = useState([]);
    const [allMerchant, setAllMerchant] = useState([]);
    const [allSignupMerchant, setAllSignupMerchant] = useState([]);
    const [selected, setSelected] = useState([]);
    const [filters, setFilters] = useState(initialFilters);
    const [isOpen, setIsOpen] = useState(false);
    const [isDetails, setIsDetails] = useState(false);
    const [pricingCourier, setPricingCourier] = useState([]);
    // const [rowData, setRowData] = useState(null);
    const [zoneConstants, setZonesConstants] = useState({});
    const [charges, setCharges] = useState([]);
    const [stateWiseCharge, setStateWiseCharge] = useState([
        { state: "", charge: "" }
    ]);
    const [zoneForm, setZoneForm] = useState({});
    const [pricingForm, setPricingForm] = useState({
        courier_id: '',
    });
    const [priceModal, setPriceModal] = useState(false);

    const handlePricingModal = () => {
        setPriceModal(true);
    };
    const closePricingModal = () => {
        setPriceModal(false);
        setPricingForm({
            courier_id: '',
        });
    };

    const handleToggleDrawer = () => {
        setIsOpen(!isOpen);
        if (isOpen) {
            setRowData(null);
        }
        setOpenAlert(false);
        setAlertMessage('');
        setSeverity('');
    };
    console.log('rowData', rowData);
    const detailsToggleDrawer = () => {
        setIsDetails(!isDetails);
        if (isDetails) {
            setRowData(null);
        }
        setOpenAlert(false);
        setAlertMessage('');
        setSeverity('');
    };

    // console.log('addModal', addModal);
    const navigate = useNavigate();
    const handleAddModal = () => {
        setAddModal(true);
        setModalAlert(false);
        setOpenAlert(false);
        setAlertMessage('');
        setSeverity('');
    };

    const handleCloseModal = () => {
        setViewData('');
        setIsEdit(false);
        setAddModal(false);
    };
    const onLoadApi = (customFilters = filters) => {
        let payload = {
            ...customFilters,
        };

        if (user?.user_type === "Merchant") {
            payload.merchant_id = user?.id;
        } else {
            payload.admin_id = user?.id;
        }
        setAllMerchant([]);
        setAllData([]);
        setFirstLoading(false);
        commonApi.post(`/merchant/list?page=${page + 1}&per_page=${rowsPerPage}`, payload)
            .then((response) => {
                setFirstLoading(true);
                if (response?.data?.data) {
                    setAllMerchant(response?.data?.data);
                    setAllData(response?.data);
                }
            })
            .catch((error) => {
                setFirstLoading(true);
                console.error('Error fetching data:', error);
            });
    };

    const onSignupLoadApi = () => {
        let postReq = {};
        if (user?.user_type === "Merchant") {
            postReq = { merchant_id: user?.id }
        } else {
            postReq = { admin_id: user?.id }
        }
        setAllSignupMerchant([]);
        setAllData([]);
        setFirstLoading(false);
        commonApi.post('/signup/list', postReq)
            .then((response) => {
                setFirstLoading(true);
                if (response?.data?.data) {
                    setAllSignupMerchant(response?.data?.data);
                    setAllData(response?.data);
                }
            })
            .catch((error) => {
                setFirstLoading(true);
                console.error('Error fetching data:', error);
            });
    };

    const onExport = () => {
        const payload = {
            ...filters,
        };

        if (user?.user_type !== "Merchant") {
            payload.admin_id = user?.id;
        }
        if (payload.status === 'all') {
            payload.status = '';
        }
        setIsLoading(true);
        commonApi.post('/merchant/export', payload)
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    navigate('/download');
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
                setOpenAlert(true);
                setAlertMessage(error?.response?.data?.msg);
                setSeverity('error')
            });
    };
    const onPriceConstants = () => {
        setIsLoading(true);
        commonApi.post('/merchant/price-constants')
            .then((response) => {
                setIsLoading(false);
                if (response?.data?.data) {
                    setZonesConstants(response?.data?.data.zones);
                    setCharges(response?.data?.data.other_charges);
                    setZoneForm(Object.fromEntries(Object.keys(response?.data?.data.zones).map((key) => [key, ''])));
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    };
    const onGetCourier = (id) => {
        setIsLoading(true);
        const postReq = { merchant_id: id ? id : rowData?.id, admin_id: user?.id, }
        commonApi.post('/merchant/get-my-couriers', postReq)
            .then((response) => {
                setIsLoading(false);
                if (response?.data?.s === 1) {
                    setPricingCourier(response?.data?.data);
                } else {
                    setPricingCourier([]);
                    setOpenAlert(true);
                    setAlertMessage(response?.data?.msg || 'No courier found for this merchant');
                    setSeverity('info');
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setOpenAlert(true);
                setAlertMessage(error?.message || 'Something went wrong');
                setSeverity('error');
                console.error('Error fetching data:', error);
            });
    };
    const onGetPrice = (row) => {
        setIsLoading(true);
        setIsEdit(true);
        const postReq = { merchant_id: row?.merchant_id, admin_id: user?.id, courier_id: row?.id }
        commonApi.post('/merchant/get-price', postReq)
            .then((response) => {
                setIsLoading(false);
                if (response?.data?.s === 1) {
                    setViewData(response?.data);
                    handlePricingModal();
                    setPricingForm((prevData) => ({
                        ...response?.data?.b2c_prices,
                        service_type: response?.data?.service_type,
                        courier_id: response?.data?.prices?.courier_id,
                        merchant_id: row?.merchant_id,
                    }));
                    setZoneForm(response?.data?.prices.zones);
                    setCharges(response?.data?.prices.other_charges);
                    setStateWiseCharge(response?.data?.prices?.state_wise_charges.length ? response?.data?.prices.state_wise_charges.map(item => ({
                        state: item.state || states[item.state_id] || "",
                        charge: item.charge
                    })) : [{ state: "", charge: "" }]);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    };
    const viewDetail = (id) => {
        setIsLoading(true);
        commonApi.post('/merchant/view', { id: id })
            .then((response) => {
                setIsLoading(false);
                if (response?.data?.data) {
                    setIsEdit(true);
                    setViewData(response?.data?.data);
                    handleAddModal();
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    }
    // useEffect(() => {
    //     onLoadApi();
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [page, rowsPerPage]);


    // You can provide any values or functions you want to make available to consumers here
    const contextValue = {
        rowData,
        setRowData,
        detailsToggleDrawer,
        isDetails,
        onPriceConstants,
        priceModal,
        handlePricingModal,
        closePricingModal,
        zoneConstants,
        setZonesConstants,
        charges,
        setCharges,
        stateWiseCharge,
        setStateWiseCharge,
        zoneForm,
        setZoneForm,
        pricingForm,
        setPricingForm,
        onGetPrice,
        pricingCourier,
        setPricingCourier,
        onGetCourier,
        isOpen,
        setIsOpen,
        handleToggleDrawer,
        initialFilters,
        viewDetail,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
        selected,
        setSelected,
        onSignupLoadApi,
        allSignupMerchant,
        setAllSignupMerchant,
        setFilters,
        filters,
        onExport,
        isEdit,
        onLoadApi,
        isLoading,
        firstLoading,
        viewData,
        allData,
        allMerchant,
        handleAddModal,
        handleCloseModal,
        setAddModal,
        addModal,
        setAllMerchant,
        setAllData,
        setViewData,
        setFirstLoading,
        setIsLoading,
        setIsEdit,
        setSeverity,
        setAlertMessage,
        setOpenAlert,
    };

    // Render the provider with children
    return <MerchantContext.Provider value={contextValue}>{children}</MerchantContext.Provider>;
}
